import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rlst-shape-info-window',
  templateUrl: './shape-info-window.component.html',
  styleUrls: ['./shape-info-window.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShapeInfoWindowComponent {

  @Input() area: number;
  @Input() radius: number;
  @Input() totalArea: number;
  @Input() name: string;
  @Input() distance: number;
  @Input() maxTotalArea: number;
  @Input() shapeType: string;

  private readonly FEET_IN_MILES: number = 1.893939394e-4;
  private readonly ONE_MILE: number = 5280;
  private readonly ONE_SQ_MILE: number = this.ONE_MILE * this.ONE_MILE;

  @Output() deleteShape: EventEmitter<void> = new EventEmitter<void>();
  @Output() nameChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() submitSearch: EventEmitter<void> = new EventEmitter<void>();

  public getDrawnArea(distance: number, type: string): string {
    let labelPrefix: string = ' Sq ';
    let measureLabel: string = 'Ft';

    switch (this.shapeType) {
      case 'circle':
        //RP-7006
        //Radius rom map.component.ts is a ration (aka fraction) of a radius.
        //instead of 5280 it would be one. For 1/2 mile it would be .5 and not 2640.
        //We need to configure this into feet and work from there.
        let radius: number = this.radius * this.ONE_MILE;

        switch (type) {
          case 'area':
            let area: number = 0;
            if (this.area > 1) {
              measureLabel = 'Mi';
              area = this.area;
            } else {
              area = Math.pow(radius, 2) * Math.PI;
            }

            return (area).toLocaleString('en-US', {maximumFractionDigits:2}) + labelPrefix + measureLabel;
            break;

          case 'radius':
            let computedRadius: number = 0;
            labelPrefix = ' ';

            if (radius / this.ONE_MILE > 1) {
              measureLabel = 'Mi';
              computedRadius = radius / this.ONE_MILE;
            } else {
              computedRadius = radius;
            }

            return (computedRadius).toLocaleString('en-US', {maximumFractionDigits:2}) + labelPrefix + measureLabel;

            break;

          case 'totalArea':
            return (this.totalArea).toLocaleString('en-US', {maximumFractionDigits:2}) + labelPrefix + 'Mi';
            break
        }
        break;

      default:
          if (distance >= 1.0) {
              return (distance).toLocaleString('en-US', {maximumFractionDigits:2}) + labelPrefix + ' Mi';
          } else {
              return (this.ONE_SQ_MILE * distance).toLocaleString('en-US', {maximumFractionDigits:2}) + labelPrefix +  ' Ft';
          }
    }

  }

  public getRulerDistance(distance: number): string {
    if (distance >= this.ONE_MILE) {
      return (distance * this.FEET_IN_MILES).toLocaleString('en-US', {maximumFractionDigits:2}) + ' Mi';
    } else {
      return distance.toLocaleString('en-US', {maximumFractionDigits:2}) + ' Ft';
    }
  }
}
